import { HeaderText as SharedHeaderText } from '../../components/atomic/text/header_text/HeaderText';
import headerTextImg from './header_text.png';
import './HeaderText.css';

/** From Figma — «Рейтинг», top 145.5 / left 408. */
export function HeaderText() {
  return (
    <SharedHeaderText
      className="rating-header-text"
      src={headerTextImg}
      alt="Рейтинг"
    />
  );
}
